export default __webpack_public_path__ + "static/P22MackinacPro-BookItalic-a841c7cf1e3ac11a957345ad4f30adbe.woff2";